var React = require('react');

function LinkedinGray (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-384 -599)"},[React.createElement("rect",{"width":"22","height":"22","transform":"translate(384 599)","fill":"#fff","key":0}),React.createElement("g",{"transform":"translate(384.127 599.116)","key":1},[React.createElement("path",{"d":"M4.737,6.7A1.942,1.942,0,1,0,2.795,4.762,1.942,1.942,0,0,0,4.737,6.7Z","transform":"translate(0 0)","fill":"#b1b1b1","key":0}),React.createElement("path",{"d":"M8.546,8.821V19.593H11.89V14.265c0-1.406.264-2.767,2.007-2.767,1.719,0,1.739,1.606,1.739,2.856v5.239h3.347V13.686c0-2.9-.625-5.132-4.016-5.132A3.517,3.517,0,0,0,11.8,10.293h-.045V8.82H8.546Zm-5.451,0h3.35V19.593H3.1V8.82Z","transform":"translate(-0.034 -0.646)","fill":"#b1b1b1","key":1})])]));
}

LinkedinGray.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = LinkedinGray;

LinkedinGray.default = LinkedinGray;
